/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ExpertSlider/theme';

export const ExpertSliderTheme = theme;
